import { useEffect, useRef } from 'react';

export const useMapLayout = (
    mapPlanRef: React.RefObject<HTMLDivElement>,
    onResize?: () => void,
    layoutKey?: string,
) => {
    const isFirstRun = useRef(true);

    useEffect(() => {
        if (!mapPlanRef.current) return;

        const element = mapPlanRef.current;
        const parentElement = element.parentElement;
        if (!parentElement) return;

        const updateLayout = () => {
            const roomsEl = element.querySelector<HTMLElement>('.map__rooms');

            element.style.height = 'auto';

            const mapSection = document.querySelector<HTMLElement>('.js-map__section');
            const isMobile = window.matchMedia(
                '(max-width: 767px), (max-width: 900px) and (orientation: landscape)',
            ).matches;
            const contentHeight = roomsEl?.offsetHeight || parentElement.clientHeight || 500;

            if (isMobile) {
                mapSection?.style.removeProperty('--container-height');
                element.style.height = `${contentHeight}px`;
            } else {
                const planHeight = Math.max(contentHeight, element.offsetHeight);
                element.style.height = `${planHeight}px`;
                mapSection?.style.setProperty('--container-height', `${planHeight}px`);
            }

            if (isFirstRun.current) {
                isFirstRun.current = false;
            } else {
                onResize?.();
            }
        };

        updateLayout();

        const resizeObserver = new ResizeObserver(updateLayout);
        resizeObserver.observe(parentElement);

        return () => {
            resizeObserver.disconnect();
        };
    }, [mapPlanRef, onResize, layoutKey]);
};
